import React from 'react';
import { graphql } from 'gatsby';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { AdsProvider } from '../lib/context/ads';
import wpImageUrl from '../lib/wp-image-url';

import Frame from './frame';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

export interface Props {
  data: {
    wordpressWpPressRelease: {
      id: number;
      date: string;
      modified: string;
      path: string;
      slug: string;
      status: string;
      type: string;
      title: string;
      content: string;
      wordpress_id: number;
      featured_media?: {
        source_url: string;
      };
    };
  };
}

export const PressReleasePageTemplate: React.FC<Props> = (props) => {
  if (!props.data) return null;

  const featuredImage =
    props.data.wordpressWpPressRelease.featured_media?.source_url;

  return (
    <ApolloProvider client={client as any}>
      <AdsProvider>
        <Layout expandedPage={false}>
          <SEO
            title={props.data.wordpressWpPressRelease.title}
            description={`Press Release || ${props.data.wordpressWpPressRelease.title}`}
            image={featuredImage ? wpImageUrl(featuredImage) : undefined}
            canonicalUrl={props.data.wordpressWpPressRelease.path}
          />

          {featuredImage ? (
            <div
              style={{
                backgroundImage: `url(${wpImageUrl(featuredImage || '')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                height: 300,
              }}
            />
          ) : null}
          <h1
            style={{ textAlign: 'center', marginTop: '.5em' }}
            dangerouslySetInnerHTML={{
              __html: props.data.wordpressWpPressRelease.title,
            }}
          />
          <div>
            <Frame
              content={`${props.data.wordpressWpPressRelease.content}
<div style="margin-top: 30px;">
  <strong>
    For more information on this press release, please contact:
    <p>
      Public Relations Manager
      <br>
      Tiffany Wright
      <br>
      <a href="mailto:tmwright@aaacarolinas.com">
        tmwright@aaacarolinas.com
      </a>
      <br>
      <a href="tel:704-737-8306">Work : 704-737-8306</a>
      <br>
      <a href="tel:704-569-7768">Cell : 704-569-7768</a>
      <br>
      <br>
    </p>
  </strong>
</div>
`}
              container
              otherHeadData={`
<link rel="stylesheet" href="/wp-content/themes/aaawpmigrate/style.css">
<link rel='stylesheet' id='wp-block-library-css'  href='https://prod-carolinas-aaa-com.azurewebsites.net/wp-includes/css/dist/block-library/style.min.css?ver=5.6.4' type='text/css' media='all' />
<link rel='stylesheet' id='aaawpmigrate-style-css'  href='/wp-content/themes/aaawpmigrate/style.css?ver=5.6.4' type='text/css' media='all' />
<link rel="stylesheet" href="https://aaacdndev.blob.core.windows.net/wordpress/css/aaa-iaresources.css">
              `}
            />
          </div>
        </Layout>
      </AdsProvider>
    </ApolloProvider>
  );
};

export default PressReleasePageTemplate;

export const query = graphql`
  query($id: Int!) {
    wordpressWpPressRelease(wordpress_id: { eq: $id }) {
      title
      content
      date(formatString: "MMMM DD, YYYY")
      modified(formatString: "MMMM DD, YYYY")
      slug
      path
      wordpress_id
      featured_media {
        source_url
      }
    }
  }
`;
